import { useMemo } from 'react';
import { useActiveServiceTemplates } from '~/hooks/reactQuery/queries/useActiveServiceTemplates';
import { useLocaleKeys } from '~/i18n';
import { serviceCostModel, serviceTemplateModel } from '~/models';
const formatSubtext = (template, t)=>{
    const recurrencePeriodsTexts = t.models.serviceBilling.recurrencePeriods;
    const costDisplayTexts = t.models.service.costDisplay;
    const periodTexts = t.billing.periods;
    const isBundle = serviceTemplateModel.isBundle(template);
    const firstPart = isBundle ? serviceTemplateModel.formatNumIncludedServices(template, t.common) : serviceCostModel.stringifyServiceCost(template.cost, undefined, periodTexts, costDisplayTexts).costDisplay;
    const secondPart = serviceTemplateModel.formatExtendedRecurrencePeriod(template, false, recurrencePeriodsTexts);
    return t.components.addServicesButton.serviceSubtext({
        firstPart,
        secondPart
    });
};
export const useServiceCatalogOptions = ()=>{
    const { data } = useActiveServiceTemplates();
    const { t } = useLocaleKeys();
    return useMemo(()=>{
        if (data == null) return [];
        return data.map((template)=>({
                id: template.id,
                name: template.name,
                body: formatSubtext(template, t),
                isBundle: serviceTemplateModel.isBundle(template)
            }));
    }, [
        data,
        t
    ]);
};
